const apiKeys = [
  "7fd74bd8-1004-4e6e-b2fd-68cd926bf3f6",
  "555f101a-de65-4498-b017-ad1042454fbb",
  "83236fa2-ac98-46be-9826-22d49713a2b9",
  "54fe6bb9-26e4-437e-ab57-356a6cd92bed",
  "29bb955e-81b8-450d-ab45-1e0f641f19e0",
  "cb5c7908-c3c5-4dd3-81e9-a316747e6636",
  "1355e44a-205d-4264-b4f6-76a3515aaec4",
  "51ea8149-ca25-41b7-9acd-53dcd0352537",
  "5ed12db3-3462-459e-9fe0-510b875a3d2d"
]

export default apiKeys;
